import React from 'react'
import { useAuth } from './AuthContext'
import { LoginView } from './LoginView'

export interface ProtectedRouteProps {
  children: React.ReactNode
  fallback?: React.ReactNode
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  fallback,
}) => {
  const { user, loading, isAuthGateEnabled } = useAuth()

  // If viewing a shared presentation in viewer mode, bypass gate
  const isViewer =
    typeof window !== 'undefined' &&
    (window.location.search.includes('mode=viewer') ||
      window.location.search.includes('mode=VIEWER'))

  if (isViewer) {
    return <>{children}</>
  }

  // If Auth Gate is disabled for component testing, bypass immediately
  if (!isAuthGateEnabled) {
    return <>{children}</>
  }

  if (loading) {
    return (
      <div className="min-h-screen w-full bg-[#101216] text-white flex flex-col items-center justify-center font-palanquin select-none">
        <div className="flex flex-col items-center gap-4">
          <div className="w-10 h-10 rounded-xl bg-primary flex items-center justify-center font-black text-white text-base shadow-lg animate-pulse">
            M
          </div>
          <div className="flex items-center gap-2 text-xs text-neutral-400">
            <div className="w-3.5 h-3.5 border-2 border-primary/40 border-t-primary rounded-full animate-spin" />
            <span>Weryfikacja tożsamości...</span>
          </div>
        </div>
      </div>
    )
  }

  if (!user) {
    if (fallback) {
      return <>{fallback}</>
    }
    return <LoginView />
  }

  return <>{children}</>
}

export default ProtectedRoute
